// adds a space after thousands e.g: 1 000, 12 300 etc.
export function formatCurrency(value) {
  return String(value).replace(/(\d)(?=(?:[0-9]{3})+\b)/g, '$1 ');
}
